"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerProductListing = void 0;
var _i18n = require("@ori/i18n");
var _presentationComponents = require("@ori/presentation-components");
var _productList = require("@ori/product-list");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _Actions = require("./components/Actions");
var _Content = require("./components/Content");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const BannerProductListing = (param)=>{
    let { className, hasBottomDivider = true } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { content, isFocusPage, isLoadingMore, isRefreshing } = (0, _contexts.useBannerProductListingContext)();
    const { loadMoreItems, numberOfLoadedProducts, shouldRenderItemCount, shouldRenderPagination, totalProductsCount } = (0, _utils.useProductListingPagination)();
    const header = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
            namespace: _constants.translationsNamespace,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Container, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Actions.Actions, {}),
                    isRefreshing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ItemsCounterSkeleton, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.Counter, {})
                ]
            })
        }), [
        isRefreshing
    ]);
    const footer = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Container, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.Pagination, {}),
                hasBottomDivider ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledDivider, {
                    "data-testid": getTestId(_constants2.BANNER_PRODUCT_LISTING_DIVIDER)
                }) : null
            ]
        }), [
        getTestId,
        hasBottomDivider
    ]);
    const list = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Content.Content, {}), []);
    var _content_rows;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        isFocusPage: isFocusPage,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.ProductList, {
            shouldLazyLoadMore: true,
            shouldRenderItemCount: shouldRenderItemCount,
            shouldRenderPagination: shouldRenderPagination,
            isLoadingMore: isLoadingMore,
            className: className,
            items: (_content_rows = content === null || content === void 0 ? void 0 : content.rows) !== null && _content_rows !== void 0 ? _content_rows : [],
            totalItemCount: totalProductsCount,
            loadedItemCount: numberOfLoadedProducts,
            HeaderComponent: header,
            FooterComponent: footer,
            ListComponent: list,
            withTranslationsProvider: false,
            loadMoreItems: loadMoreItems
        })
    });
};
exports.BannerProductListing = BannerProductListing;
